const rooms = {
  "sound-and-touch": {videoFile: "sound-and-touch-audio.mp4", label: 'Sound & Touch'},
  "it-shines": {videoFile: "it-shines-audio.mp4", label: 'It Shines'},
  "flash-of-genius": {videoFile: "flash-of-genius-audio.mp4", label: 'Flash Of Genius'},
  "cloth-mother-vs-metal-mother": {videoFile: "cloth-mother-vs-metal-mother-audio.mp4", label: 'Cloth Mother VS Metal Mother'},
  "car-massacre-picnic": {videoFile: "car-massacre-picnic-audio.mp4", label: 'Car Massacre Picnic'},
  "the-killer-is-on-the-phone": {videoFile: "the-killer-is-on-the-phone-audio.mp4", label: 'The Killer Is On The Phone'},
};

export default rooms;